import {
  eventDispatcher,
  TOPICS,
  IAlertBanner,
  IActionBarUpdate,
} from '@origin-digital/event-dispatcher';

import { errorTracking } from 'src/utils/tracking';

const showNotification = (type: IAlertBanner['payload']['type']) => (
  message: string,
  heading?: string,
) => {
  eventDispatcher.dispatch({
    payload: {
      heading,
      message,
      type,
    },
    topic: TOPICS.ALERT_BANNER_OPEN,
  });
};

export const showErrorNotification = (message: string, heading?: string): void => {
  showNotification('error')(message, heading);
  errorTracking(Error(message));
};

export const showInfoNotification = (message: string): void => {
  showNotification('info')(message);
};

export const showSuccessNotification = (message: string): void => {
  showNotification('success')(message);
};

export const hideNotification = (): void => {
  eventDispatcher.dispatch({
    payload: {},
    topic: TOPICS.ALERT_BANNER_CLOSE,
  });
};

export const updateActionBar = (payload: IActionBarUpdate['payload']): void => {
  eventDispatcher.dispatch({
    payload,
    topic: TOPICS.ACTION_BAR_UPDATE,
  });
};
